import { formatISO, startOfYear } from 'date-fns'
import { FetchAccountsReceivableQuery } from '../../generated'

export interface AccountsReceivableFilters {
  startDate?: string
  endDate?: string
  searchTerm?: string
}

export interface AccountsReceivableState {
  arEntries: FetchAccountsReceivableQuery['fetchAccountsReceivable']['arEntries']
  arEntriesSummary: FetchAccountsReceivableQuery['fetchAccountsReceivable']['summary']
  filters: AccountsReceivableFilters
  loading: boolean
}

export const accountsReceivableInitialState: AccountsReceivableState = {
  arEntries: [],
  arEntriesSummary: {
    totalARs: 0,
    totalInvoiced: 0
  },
  filters: {
    startDate: formatISO(startOfYear(new Date())).split('T')[0],
    endDate: formatISO(new Date()).split('T')[0]
  },
  loading: false
}

export enum AccountsReceivableActionType {
  SET_AR_ENTRIES = 'setArEntries',
  SET_AR_ENTRIES_SUMMARY = 'setArEntriesSummary',
  SET_FILTERS = 'setFilters',
  SET_LOADING = 'setLoading',
  RESET_FILTERS = 'resetFilters'
}

export type AccountsReceivableAction =
  | {
      type: AccountsReceivableActionType.SET_AR_ENTRIES
      arEntries: FetchAccountsReceivableQuery['fetchAccountsReceivable']['arEntries']
    }
  | {
      type: AccountsReceivableActionType.SET_AR_ENTRIES_SUMMARY
      arEntriesSummary: FetchAccountsReceivableQuery['fetchAccountsReceivable']['summary']
    }
  | { type: AccountsReceivableActionType.SET_FILTERS; filters: AccountsReceivableFilters }
  | { type: AccountsReceivableActionType.SET_LOADING; loading: boolean }
  | { type: AccountsReceivableActionType.RESET_FILTERS }

export interface AccountsReceivableListingProps {
  arEntries: FetchAccountsReceivableQuery['fetchAccountsReceivable']['arEntries']
  loading: boolean
  refetch: () => void
}
